// extracted by mini-css-extract-plugin
module.exports = {"c1ni1sin":"c1ni1sin","b1gqp5f7":"b1gqp5f7"};